<div id="content" class="allcp-form" ng-controller="FailAnalyticController" ng-init="init()">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >
                    
                    <div class="row mt50">
                        <div class="col-lg-6">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-times"></i>
                                </div>
                                <div class="inner">
                                    <p>İade Olan Kargo</p>
                                    <h3><i class="fa fa-pie-chart"></i> 
                                        {{ data.fail_count }}
                                    </h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="small-box bg-orange">
                                <div class="icon small-box-icon-orange">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>İade Olan Toplam Kargo Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.fail_total | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive" ng-if="data.orders.data.length > 0">
                                <table class="table table-hover tc-checkbox-1 fs13">
                                    <thead>
                                        <tr class="bg-light">
                                            <th class="text-center">
                                                <label class="option block mn ml4" style="display:block">
                                                    <input type="checkbox" 
                                                        name="deleted[]" ng-model="master" ng-click="toggleSelection($event)"  id="checkboxAll" >
                                                    <span class="checkbox mn"></span>
                                                </label>
                                            </th>
                                            <th>
                                                NO
                                                <a ng-click="sort('id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Açıklama</th>
                                            <th>Teslimat M.</th>
                                            <th>Ödeme Türü</th>
                                            <th>Ödeme Miktarı</th>
                                            <th>
                                                Personel
                                                <a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Teslim Süresi</th>
                                            
                                            <th>
                                                Tarihi
                                                <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                           <th>
                                                Türü
                                                <a ng-click="sort('work_type','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('work_type','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>
                                                Durumu
                                                <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th ng-repeat="item in data.fields">{{ item.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr 
                                        dir-paginate="item in data.orders.data | itemsPerPage: 30" 
                                        total-items="data.orders.total" 
                                        current-page="data.orders.current_page"
                                        ng-class="{ 'success' : item.status.id == data.successID  }">
                                        <td class="clickable-row">
                                            <label class="option block mn">
                                                <input type="checkbox" ng-click="addSelectedItem(item.id)" ng-checked="selectedItem.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                                                <span class="checkbox mn"></span>
                                            </label>
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">#{{item.id}}</td>
                                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.name | cut:true:40:' ...' }}</td>
                                        
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            {{ item.location.name }} - {{ item.location.phone_number }}
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            <span ng-if="item.order_payment == 'online'">Kapıda Ödeme</span>
                                            <span ng-if="item.order_payment == 'offline'">Ödendi</span>
                                            <span ng-if="item.order_payment == 'payable'">Karşıdan Ödemeli</span>
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            {{ item.order_payment == 'online' ? item.price + '₺' : '-' }}
                                        </td>
            
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.worker.user.full_name }} </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ humanizeDuration(item.time, { units: ['d', 'h'] }) }}</td>
                                        <!--
                                            <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.distance }} KM</td>
                                        -->
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td> -->
                                        <!-- <td 
                                            ng-repeat="fields in data.steps | orderBy:'sort'"
                                            class="clickable-row" 
                                            ng-click="getOrderDetails(item)">
                                            <span ng-repeat="field in item.logs | filter:{ proccess: fields.id }" ng-if="$index == 0">
                                                {{ field.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}
                                            </span>
                                        </td> -->
                                        
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.work_type.name }}</td>
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.note_count }}</td>								
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.image_count }}</td>								
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.form ? item.form.name : '-' }}</td> -->
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.rate ? item.rate : '-' }}</td> -->								
            
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            <span ng-if="item.status"ng-style="{'color': item.status.color }">{{ item.status.name }}</span>	
                                            <span ng-if="!item.status">Created</span>
                                        </td>
                                        <td 
                                            ng-repeat="fields in data.fields"
                                            class="clickable-row" 
                                            ng-click="getCustomerDetails(item.id)">
                                            <span ng-repeat="field in item.fields_values">
                                                {{ fields.id == field.customer_field_id ? field.value : '' }}
                                            </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <dir-pagination-controls 
                                    boundary-links="true" 
                                    on-page-change="getPage(newPageNumber)" 
                                    template-url="dirPagination.tpl.html"
                                    class="pagination-lg pagination">
                                </dir-pagination-controls>
                            </div>

                            <div class="table-responsive" ng-if="data.orders.data.length == 0">
                                <div class="alert alert-default pastel">
                                    <i class="fa fa-info pr10"></i>
                                    <strong>
                                        Aradığınız kritelerde iş bulunamadı!
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>